import constants from '@/constants';

const { COUPON_CODE, PLAN_ID } = constants.MONTHLY_EXCLUSIVE_COUPON;

const normalizeCoupon = coupon => (coupon || '').toString().trim().toUpperCase();

export default {
  COUPON_CODE,
  PLAN_ID,
  INVALID_PLAN_MESSAGE: 'Este cupom é válido apenas para o plano mensal.',

  // A campanha só vale quando os dois query params vêm exatamente com esses valores.
  isCampaignQuery(query = {}) {
    return query.couponCode === COUPON_CODE && query.planid === PLAN_ID;
  },

  isExclusiveCoupon(coupon) {
    return normalizeCoupon(coupon) === COUPON_CODE;
  },

  isCampaignPlan(planId) {
    return planId === PLAN_ID;
  },
};
